import en from "./en-US";
import pt from "./pt-BR";
import fr from "./fr-FR";
import sw from "./sv-SE";

export default {
  "en-us": en,
  "pt-br": pt,
  "fr-fr": fr,
  "sv-se": sw
};



// WEBPACK FOOTER //
// ./src/utils/locales/index.js